import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import LabelWithInputField from "./LabelWithInputField" ;
import SuccessMessage from "../classes/SuccessMessage" ;
import MeetingDTO from "../models/MeetingDTO" ;
import EventBus from "../utils/EventBus" ;
import MaterialIcons from "../icons/MaterialIcons" ;
import User from "../models/User" ;
import PageNavigator from "../classes/PageNavigator" ;
import IconButton from "./IconButton" ;
import LabelWithDateTimeField from "./LabelWithDateTimeField" ;
import PopupWrapperView from "./PopupWrapperView" ;
import Button from "./Button" ;
import DBSaveStatus from "../utils/DBSaveStatus" ;
import DateTime from "../core/DateTime" ;
import TextView from "./TextView" ;
import FailureMessage from "../classes/FailureMessage" ;
import RPCServices from "../rpc/RPCServices" ;
import { Runnable } from "../classes/core" ;
import { BuildContext } from "../classes/BuildContext" ;

type _AddAttendeeButtonOnPressed = ( d3eState : DemoCreationViewRefs ) => void ;

type _CancelButtonOnPressed = ( d3eState : DemoCreationViewRefs ) => void ;

type _ScheduleMeetingOnPressed = ( d3eState : DemoCreationViewRefs ) => void ;

type _LabelWithInputField111OnChanged = ( text : string,d3eState : DemoCreationViewRefs ) => void ;

type _LabelWithInputFieldOnChanged = ( text : string,d3eState : DemoCreationViewRefs ) => void ;

type _LabelWithDateField6OnChanged = ( text : DateTime,d3eState : DemoCreationViewRefs ) => void ;

type _LabelWithDateField7OnChanged = ( text : DateTime,d3eState : DemoCreationViewRefs ) => void ;


  export  interface  DemoCreationViewProps extends  BaseUIProps {   key?: string ;
   user: User ;
   meeting: MeetingDTO ;
 }
/// To store state data for DemoCreationView 
   class  DemoCreationViewRefs {  public addAttendeeButton: AddAttendeeButtonState = new AddAttendeeButtonState() ;
  public cancelButton: CancelButtonState = new CancelButtonState() ;
  public scheduleMeeting: ScheduleMeetingState = new ScheduleMeetingState() ;
 }

   interface  ScheduleMeetingWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: DemoCreationViewRefs ;
   _onScheduleMeetingPressed?: _ScheduleMeetingOnPressed ;
 }

   class  ScheduleMeetingState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _ScheduleMeetingWithState extends  ObservableComponent<ScheduleMeetingWithStateProps> {   scheduleMeetingFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : ScheduleMeetingWithStateProps ) {
 super(props);

this.initState();
 }
  public get scheduleMeeting (  ) : ScheduleMeetingState {
 return this.props.d3eState.scheduleMeeting ; 
 }
  public get d3eState (  ) : DemoCreationViewRefs {
 return this.props.d3eState ; 
 }
  public get _onScheduleMeetingPressed (  ) : _ScheduleMeetingOnPressed {
 return this.props._onScheduleMeetingPressed ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('scheduleMeeting',null,this.scheduleMeeting);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'scheduleMeeting', 'scheduleMeeting.hover' ],this.rebuild);
 }
  public scheduleMeetingOnEnter ( event ) : void {
 return this.scheduleMeeting.setHover(true) ; 
 }
  public scheduleMeetingOnExit ( event ) : void {
 return this.scheduleMeeting.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.scheduleMeeting.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ width:100, child:Button({ padding:cStyle.tButtonPrimaryPaddingOn, decoration:cStyle.tButtonPrimaryDecorationOn, disable:this.scheduleMeeting.disable, onPressed:(  ) => {
 this._onScheduleMeetingPressed(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Schedule Meeting' }), onEnter:( event ) => {
 this.scheduleMeetingOnEnter(event);
 }
, onExit:( event ) => {
 this.scheduleMeetingOnExit(event);
 }
 }), className:'Primary xf79 hc' }) ; 
 }
 }
function ScheduleMeetingWithState ( props : ScheduleMeetingWithStateProps ) {
 return React.createElement(_ScheduleMeetingWithState,props) ; 
 }


   interface  CancelButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: DemoCreationViewRefs ;
   _cancelButtonHandler?: _CancelButtonOnPressed ;
 }

   class  CancelButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _CancelButtonWithState extends  ObservableComponent<CancelButtonWithStateProps> {   cancelButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : CancelButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get cancelButton (  ) : CancelButtonState {
 return this.props.d3eState.cancelButton ; 
 }
  public get d3eState (  ) : DemoCreationViewRefs {
 return this.props.d3eState ; 
 }
  public get _cancelButtonHandler (  ) : _CancelButtonOnPressed {
 return this.props._cancelButtonHandler ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('cancelButton',null,this.cancelButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'cancelButton', 'cancelButton.hover' ],this.rebuild);
 }
  public cancelButtonOnEnter ( event ) : void {
 return this.cancelButton.setHover(true) ; 
 }
  public cancelButtonOnExit ( event ) : void {
 return this.cancelButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.cancelButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ width:100, child:Button({ padding:cStyle.tButtonSecondaryPaddingOn, decoration:cStyle.tButtonSecondaryDecorationOn, disable:this.cancelButton.disable, onPressed:(  ) => {
 this._cancelButtonHandler(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Cancel' }), onEnter:( event ) => {
 this.cancelButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.cancelButtonOnExit(event);
 }
 }), className:'Secondary x020 hc' }) ; 
 }
 }
function CancelButtonWithState ( props : CancelButtonWithStateProps ) {
 return React.createElement(_CancelButtonWithState,props) ; 
 }


   interface  AddAttendeeButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: DemoCreationViewRefs ;
   _onAddAttendeeButtonPressed?: _AddAttendeeButtonOnPressed ;
 }

   class  AddAttendeeButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _AddAttendeeButtonWithState extends  ObservableComponent<AddAttendeeButtonWithStateProps> {   addAttendeeButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : AddAttendeeButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get addAttendeeButton (  ) : AddAttendeeButtonState {
 return this.props.d3eState.addAttendeeButton ; 
 }
  public get d3eState (  ) : DemoCreationViewRefs {
 return this.props.d3eState ; 
 }
  public get _onAddAttendeeButtonPressed (  ) : _AddAttendeeButtonOnPressed {
 return this.props._onAddAttendeeButtonPressed ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('addAttendeeButton',null,this.addAttendeeButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'addAttendeeButton', 'addAttendeeButton.hover' ],this.rebuild);
 }
  public addAttendeeButtonOnEnter ( event ) : void {
 return this.addAttendeeButton.setHover(true) ; 
 }
  public addAttendeeButtonOnExit ( event ) : void {
 return this.addAttendeeButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.addAttendeeButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ width:100, child:Button({ padding:cStyle.tButtonSecondaryPaddingOn, decoration:cStyle.tButtonSecondaryDecorationOn, disable:this.addAttendeeButton.disable, onPressed:(  ) => {
 this._onAddAttendeeButtonPressed(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Add' }), onEnter:( event ) => {
 this.addAttendeeButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.addAttendeeButtonOnExit(event);
 }
 }), className:'Secondary xfef hc' }) ; 
 }
 }
function AddAttendeeButtonWithState ( props : AddAttendeeButtonWithStateProps ) {
 return React.createElement(_AddAttendeeButtonWithState,props) ; 
 }


   class  _DemoCreationViewState extends  ObservableComponent<DemoCreationViewProps> {   static defaultProps = { user:null, meeting:null } ;
   d3eState: DemoCreationViewRefs = new DemoCreationViewRefs() ;
   email: string = '' ;
  private _editInitListeners: Array<Runnable> = [ ] ;
  private _d3eModelErrors: Array<string> = [ ] ;
  private _subjectErrors: Array<string> = [ ] ;
  private _startTimeErrors: Array<string> = [ ] ;
  private _endTimeErrors: Array<string> = [ ] ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : DemoCreationViewProps ) {
 super(props);

this.initState();
 }
  public get user (  ) : User {
 return this.props.user ; 
 }
  public get meeting (  ) : MeetingDTO {
 return this.props.meeting ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('user',this.props.user);

this.updateSyncProperty('meeting',this.props.meeting);

this.on([ 'email', 'meeting', 'meeting.attendees', 'meeting.endTime', 'meeting.startTime', 'meeting.subject', 'subjectErrors' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : DemoCreationViewProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.user !== this.props.user ) {
 this.updateObservable('user',prevProps.user,this.props.user);

this.fire('user',this);
 }

if ( prevProps.meeting !== this.props.meeting ) {
 this.updateObservable('meeting',prevProps.meeting,this.props.meeting);

this.fire('meeting',this);
 }
 }
  public setEmail ( val : string ) : void {
 let isValChanged :boolean=this.email !== val;

if ( !isValChanged ) {
 return ; 
 }

this.email=val;

this.fire('email',this);
 }
  public get d3eModelErrors (  ) : Array<string> {
 return this._d3eModelErrors?? [] ; 
 }
  public set d3eModelErrors ( val : Array<string> ) {
 this._d3eModelErrors.clear();

this._d3eModelErrors.addAll(val);
 }
  public get subjectErrors (  ) : Array<string> {
 return this._subjectErrors?? [] ; 
 }
  public set subjectErrors ( val : Array<string> ) {
 this._subjectErrors.clear();

this._subjectErrors.addAll(val);
 }
  public async computeSubjectErrors (  ) : Promise<void> {
 this.subjectErrors=[ ];

let it :string=this.meeting.subject;

if ( it == null || it === '' ) {
 this.subjectErrors.add('subject cannot be empty.');
 }

this.fire('subjectErrors',this);
 }
  public get startTimeErrors (  ) : Array<string> {
 return this._startTimeErrors?? [] ; 
 }
  public set startTimeErrors ( val : Array<string> ) {
 this._startTimeErrors.clear();

this._startTimeErrors.addAll(val);
 }
  public async computeStartTimeErrors (  ) : Promise<void> {
 this.startTimeErrors=[ ];

let it :DateTime=this.meeting.startTime;

if ( !it ) {
 this.startTimeErrors.add('startTime cannot be empty.');
 }

this.fire('startTimeErrors',this);
 }
  public get endTimeErrors (  ) : Array<string> {
 return this._endTimeErrors?? [] ; 
 }
  public set endTimeErrors ( val : Array<string> ) {
 this._endTimeErrors.clear();

this._endTimeErrors.addAll(val);
 }
  public async computeEndTimeErrors (  ) : Promise<void> {
 this.endTimeErrors=[ ];

let it :DateTime=this.meeting.endTime;

if ( !it ) {
 this.endTimeErrors.add('endTime cannot be empty.');
 }

this.fire('endTimeErrors',this);
 }
  public setEditDefaults (  ) : void {
  }
  public get isEditValid (  ) : boolean {
 if ( this.subjectErrors.isNotEmpty ) {
 return false ; 
 }

if ( this.startTimeErrors.isNotEmpty ) {
 return false ; 
 }

if ( this.endTimeErrors.isNotEmpty ) {
 return false ; 
 }

return true ; 
 }
  public validate (  ) : Array<string> {
 let errors :Array<string>=[ ];

this.computeSubjectErrors();

errors.addAll(this.subjectErrors);

this.computeStartTimeErrors();

errors.addAll(this.startTimeErrors);

this.computeEndTimeErrors();

errors.addAll(this.endTimeErrors);

return errors ; 
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return PopupWrapperView({ title:this.meeting.saveStatus !== DBSaveStatus.New ? 'Edit Meeting' : 'Schedule Meeting', content:ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.center, mainAxisAlignment:ui.MainAxisAlignment.center, children:[ TextView({ data:'Schedule Meeting in Development mode please do not create real meetings', className:'xe26 hc', key:'0' }), LabelWithInputField({ name:'Enter Subject', placeHolder:'Enter Subject', value:this.meeting.subject, isRequired:true, errors:this.subjectErrors, onChanged:( text ) => {
 this.labelWithInputField111onChanged(text,this.d3eState);
 }
, className:'x85 hc h', key:'1' }), ui.Row({ children:[ ui.Container({ width:200, child:LabelWithInputField({ name:'Email', placeHolder:'Enter Email', isRequired:true, value:this.email, onChanged:( text ) => {
 this.labelWithInputFieldonChanged(text,this.d3eState);
 }
 }), key:'0', className:'xf09 hc' }), AddAttendeeButtonWithState({ d3eState:this.d3eState, _onAddAttendeeButtonPressed:this.onAddAttendeeButtonPressed, key:'1' }) ], className:'x590 hc h', key:'2' }), (this.meeting.attendees).expand(( attendee ) => [ ui.Row({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ TextView({ data:attendee, className:'x7f6', key:'0' }), IconButton({ icon:MaterialIcons.delete, onPressed:(  ) => {
 this.onDeleteAttendeeButtonPressed(attendee,this.d3eState);
 }
, key:'1' }) ], className:'xbe0 hc h', key:attendee?.toString() }) ]), LabelWithDateTimeField({ name:'Start Date & Time', placeHolder:'Pick a date and time', value:this.meeting.startTime, onChanged:( text ) => {
 this.labelWithDateField6onChanged(text,this.d3eState);
 }
, className:'xaf2 hc h', key:'4' }), LabelWithDateTimeField({ name:'End Date & Time', placeHolder:'Pick a date and time', value:this.meeting.endTime, onChanged:( text ) => {
 this.labelWithDateField7onChanged(text,this.d3eState);
 }
, className:'xf33 hc h', key:'5' }) ], className:'xfd1 hc h' }), buttons:[ CancelButtonWithState({ d3eState:this.d3eState, _cancelButtonHandler:this.cancelButtonHandler, key:'0' }), ScheduleMeetingWithState({ d3eState:this.d3eState, _onScheduleMeetingPressed:this.onScheduleMeetingPressed, key:'1' }) ], className:ui.join('DemoCreationView hc vc ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public cancelButtonHandler  =  ( d3eState : DemoCreationViewRefs ) : void  =>  {
 this.meeting.restore();

this.navigator.close();
 }
  public onScheduleMeetingPressed  =  async  ( d3eState : DemoCreationViewRefs ) : Promise<void>  =>  {
 //  Basic validation

if ( this.meeting.subject === null || this.meeting.subject.trim().isEmpty ) {
 EventBus.get().fire(new FailureMessage({ message:'Subject is required' }));

return ; 
 }

if ( this.meeting.attendees === null || this.meeting.attendees.length === 0 ) {
 EventBus.get().fire(new FailureMessage({ message:'Please add at least one attendee' }));

return ; 
 }

if ( this.meeting.startTime === null ) {
 EventBus.get().fire(new FailureMessage({ message:'Start date and time is required' }));

return ; 
 }

if ( this.meeting.endTime === null ) {
 EventBus.get().fire(new FailureMessage({ message:'End date and time is required' }));

return ; 
 }

if ( this.meeting.endTime.isBefore(this.meeting.startTime) ) {
 EventBus.get().fire(new FailureMessage({ message:'End date and time must be after start date and time' }));

return ; 
 }

if ( this.meeting.saveStatus === DBSaveStatus.New ) {
 let eventId :string=( await RPCServices.getLeadService().createTeamsMeeting(this.user.mAccount,this.meeting.subject,this.meeting.startTime.date,this.meeting.endTime.date,'UTC',this.meeting.attendees));

if ( eventId !== null ) {
 EventBus.get().fire(new SuccessMessage({ message:'Meeting scheduled successfully' }));

this.meeting.setEventId(eventId);

this.navigator.close();
 }
 else {
 EventBus.get().fire(new FailureMessage({ message:'Failed to schedule meeting. Please try again.' }));
 }
 }
 else {
 let isUpdated :boolean=( await RPCServices.getLeadService().updateMeeting(this.user.mAccount,this.meeting.eventId,this.meeting.subject,this.meeting.startTime.date,this.meeting.endTime.date,'UTC'));

if ( isUpdated ) {
 EventBus.get().fire(new SuccessMessage({ message:'Meeting updated successfully' }));

this.navigator.close();
 }
 else {
 EventBus.get().fire(new FailureMessage({ message:'Failed to update meeting. Please try again.' }));
 }
 }
 }
  public onAddAttendeeButtonPressed  =  ( d3eState : DemoCreationViewRefs ) : void  =>  {
 if ( this.email === null || this.email.trim() === '' ) {
 return ; 
 }

if ( this.meeting.attendees === null ) {
 this.meeting.setAttendees([  ]);
 }
 else {
 if ( this.email.contains('@') === false ) {
 EventBus.get().fire(new FailureMessage({ message:'Please enter a valid email address' }));

return ; 
 }
 else {
 //  Check if the email already exists in the attendees list

for( let attendee of this.meeting.attendees ) {
 if ( attendee.toLowerCase() === this.email.trim().toLowerCase() ) {
 EventBus.get().fire(new FailureMessage({ message:'This email address is already added as an attendee' }));

return ; 
 }
 }

this.meeting.attendees.add(this.email.trim());
 }
 }
 }
  public onDeleteAttendeeButtonPressed  =  ( attendee : string,d3eState : DemoCreationViewRefs ) : void  =>  {
 this.meeting.attendees.remove(attendee);
 }
  public labelWithInputField111onChanged  =  ( val : string,d3eState : DemoCreationViewRefs ) : void  =>  {
 this.meeting.setSubject(val);
 }
  public labelWithInputFieldonChanged  =  ( val : string,d3eState : DemoCreationViewRefs ) : void  =>  {
 this.setEmail(val);
 }
  public labelWithDateField6onChanged  =  ( val : DateTime,d3eState : DemoCreationViewRefs ) : void  =>  {
 this.meeting.setStartTime(val);
 }
  public labelWithDateField7onChanged  =  ( val : DateTime,d3eState : DemoCreationViewRefs ) : void  =>  {
 this.meeting.setEndTime(val);
 }
  public get navigator (  ) : PageNavigator {
 return PageNavigator.of(this.context) ; 
 }
  public get addAttendeeButton (  ) {
 return this.d3eState.addAttendeeButton ; 
 }
  public get cancelButton (  ) {
 return this.d3eState.cancelButton ; 
 }
  public get scheduleMeeting (  ) {
 return this.d3eState.scheduleMeeting ; 
 }
 }
export default function DemoCreationView ( props : DemoCreationViewProps ) {
 return React.createElement(_DemoCreationViewState,{ ..._DemoCreationViewState.defaultProps, ...props }) ; 
 }
